import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory('app-error')
  .extendHookCollectionsFactory('app-errors')
  .factory()

export {
  Provider as ErrorProvider,
  useStore as useErrorStore,
}
